module.exports = __webpack_public_path__ + "img/hyl_title4.153ba117.png";